import type { IconNode } from '../types';

/**
 * @name flower-rose
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTQgNmE0IDQgMCAxIDEtMi0zLjQ2IiAvPgogIDxjaXJjbGUgY3g9IjEyIiBjeT0iNiIgcj0iMiIgLz4KICA8cGF0aCBkPSJNMTAgNmE0IDQgMCAwIDEgOCAwdjJBNiA2IDAgMCAxIDYgOFY2IiAvPgogIDxwYXRoIGQ9Ik0xMiAxNHY4IiAvPgogIDxwYXRoIGQ9Ik0xMiAyMmMtNC4yIDAtNy0xLjY2Ny03LTUgNC4yIDAgNyAxLjY2NyA3IDUiIC8+CiAgPHBhdGggZD0iTTEyIDIyYzQuMiAwIDctMS42NjcgNy01LTQuMiAwLTcgMS42NjctNyA1IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/flower-rose
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const flowerRose: IconNode = [
  ['path', { d: 'M14 6a4 4 0 1 1-2-3.46', key: '1tmmew' }],
  ['circle', { cx: '12', cy: '6', r: '2', key: '1jj5th' }],
  ['path', { d: 'M10 6a4 4 0 0 1 8 0v2A6 6 0 0 1 6 8V6', key: '1afcn7' }],
  ['path', { d: 'M12 14v8', key: '1tn2tj' }],
  ['path', { d: 'M12 22c-4.2 0-7-1.667-7-5 4.2 0 7 1.667 7 5', key: 'i9nrne' }],
  ['path', { d: 'M12 22c4.2 0 7-1.667 7-5-4.2 0-7 1.667-7 5', key: '1ekthu' }],
];

export default flowerRose;
